import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class PageService {

  constructor(private meta: Meta, private title: Title) {}

  updateTitle(title: string) {
    this.title.setTitle(title)
    this.meta.updateTag({
      name: 'twitter:title',
      content: title
    })
    this.meta.updateTag({
      property: 'og:title',
      content: title
    })
  }

  updateDescription(description: string) {
    this.meta.updateTag({
      name: 'description',
      content: description
    })
    this.meta.updateTag({
      name: 'twitter:description',
      content: description
    })
    this.meta.updateTag({
      property: 'og:description',
      content: description
    })
  }

  updateMetaKeywords(keywords: string) {
    this.meta.addTags([
      { name: 'keywords', content: keywords }
    ]);
    }

}
